import { render, staticRenderFns } from "./ProjectRechargeRecordConfirm.vue?vue&type=template&id=0a183963&scoped=true"
import script from "./ProjectRechargeRecordConfirm.vue?vue&type=script&lang=js"
export * from "./ProjectRechargeRecordConfirm.vue?vue&type=script&lang=js"
import style0 from "./ProjectRechargeRecordConfirm.vue?vue&type=style&index=0&id=0a183963&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a183963",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a183963')) {
      api.createRecord('0a183963', component.options)
    } else {
      api.reload('0a183963', component.options)
    }
    module.hot.accept("./ProjectRechargeRecordConfirm.vue?vue&type=template&id=0a183963&scoped=true", function () {
      api.rerender('0a183963', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/clientManage/customerPointsManagement/dialogs/components/ProjectRechargeRecordConfirm.vue"
export default component.exports